import { useState } from "react";
import { Medium } from "../../../types/product";
import { SearchArticleFragment, SearchProductFragment, useSearchLazyQuery } from "../../../generated/storefront";
import { useAppState } from "../../../state";
import { productSearchFilter } from "../../../helpers/product";

export const useSearch = () => {
  const mediumValues = Object.values(Medium);
  const { selectedCountry } = useAppState();
  const [mediums, setMediums] = useState<Medium[]>(mediumValues);
  const [products, setProducts] = useState<SearchProductFragment[]>();
  const [articles, setArticles] = useState<SearchArticleFragment[]>([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [search, { loading }] = useSearchLazyQuery();

  const searchItems = async (query: string) => {
    setLoadingProducts(true);

    const { data: favouriteProductsData } = await search({
      variables: {
        limit: 6,
        query,
        country: selectedCountry,
        productFilters: { tag: "favourite" },
      },
      fetchPolicy: "no-cache",
    });
    const favouriteProductsResult = favouriteProductsData?.search.nodes || [];
    const favouriteProducts = (favouriteProductsResult?.filter(productSearchFilter) as SearchProductFragment[]) || [];

    setProducts(favouriteProducts);
    const searchedArticles =
      (favouriteProductsResult?.filter((node) => node?.__typename === "Article") as SearchArticleFragment[]) || [];
    setArticles(searchedArticles);
    setLoadingProducts(false);
  };

  const onSearchChange = async (value: string) => {
    if (value) {
      const searchedMediums = value ? mediums.filter((medium) => medium.match(value)) : [];
      setMediums(searchedMediums.length ? searchedMediums : mediums);
      await searchItems(value);
    }
  };

  return {
    onSearchChange,
    mediums,
    products,
    articles,
    loadingProducts: loading || loadingProducts,
  };
};
